module.exports = __webpack_public_path__ + "img/callcenter.d2ccc030.png";